import { reactive } from 'vue';

export const userState = reactive({
    isAuthenticated: false,
    user: null,
    type: 'Bearer',
    token: ''
});

export const setUserState = (user, token, type) => {
    userState.isAuthenticated = true;
    userState.user = user;
    userState.token = token;
    userState.type = type || userState.type;
};